import { render, staticRenderFns } from "./BtnDownloadXls.vue?vue&type=template&id=77f33a44&scoped=true"
import script from "./BtnDownloadXls.vue?vue&type=script&lang=js"
export * from "./BtnDownloadXls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f33a44",
  null
  
)

export default component.exports